import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createBoatPlace, useAllBoatPlaces } from '../lib/boats';

export default function NewBoatPlace() {
  const navigate = useNavigate();
  const { places } = useAllBoatPlaces();
  const [number, setNumber] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    const trimmed = number.trim();
    if (!trimmed) {
      setError('Platsnummer krävs.');
      return;
    }
    if (places.some((p) => p.number === trimmed)) {
      setError(`Plats ${trimmed} finns redan.`);
      return;
    }
    setSaving(true);
    try {
      await createBoatPlace(trimmed);
      navigate(`/admin/batplatser/${trimmed}`);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="space-y-4">
      <Link to="/admin/batplatser" className="text-sm underline">
        ← Tillbaka
      </Link>
      <h1 className="text-xl font-bold">Ny båtplats</h1>
      {error && <p className="text-sm text-red-700">{error}</p>}
      <form onSubmit={handleSubmit} className="space-y-2 max-w-sm">
        <label className="block">
          <span className="text-sm">Platsnummer</span>
          <input
            type="text"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            className="mt-1 w-full rounded border-gray-300 px-2 py-2"
            placeholder="t.ex. 33"
          />
        </label>
        <button
          type="submit"
          disabled={saving || !number.trim()}
          className="px-3 py-2 bg-navy text-white rounded disabled:opacity-50"
        >
          {saving ? 'Sparar…' : 'Skapa plats'}
        </button>
      </form>
    </div>
  );
}
